// extracted by mini-css-extract-plugin
export default {"file-upload-dropzone":"CreateEditReadingExercise_file-upload-dropzone__66EQS"};